<template>
    <form>
        <div class="card rounded-0 mb-3">
            <h3 class="card-header">
                Privacy Settings
            </h3>
            <div class="card-body">
                <div class="alert-success">{{successMessage}}</div>
                <div class="alert-warning">{{failureMessage}}</div>
                <div class="d-flex custom-control custom-checkbox pb-2" v-for="(setting, index) in privacySettings" :key="setting.id">
                    <input type="checkbox" class="custom-control-input consent-request" :id="setting.id" :name="setting.id" v-model="privacySelections[index]">
                    <label class="custom-control-label" :for="setting.id" v-html="setting.content">
                    </label>
                </div>
            </div>
            <div class="card-footer text-right">
                <a href class="btn btn-light disable-on-invalid" @click.prevent="PostForm">Update Privacy Settings</a>
            </div>
        </div>
    </form>
    <LicenseModal></LicenseModal>
</template>

<script>
    import accountApiClient from '@/services/apiServices/accountApiClient.js'
    import LicenseModal from '@/components/terms/LicenseModal.vue';

    export default {
        name: 'PrivacyPanel',
        components: {
            LicenseModal
        },
        props: {
            privacySettings: {
                type: Array,
                default: () => []
            },
            initialPrivacySelections: {
                type: Array,
                default: () => []
            },
        },
        data: function () {
            return {
                privacySelections: [],
                successMessage: "",
                failureMessage: ""
            };
        },
        methods: {
            PostForm: async function () {
                var returnitems = [];
                for (var i = 0; i < this.privacySettings.length; i++) {
                    returnitems[i] = {
                        id: this.privacySettings[i].id,
                        isChecked: this.privacySelections.length > i ? this.privacySelections[i] : false
                    };
                }
                var value = await accountApiClient.PostPrivacy(returnitems);
                if (value.status == 200) {
                    if (value.data.success) {
                        this.successMessage = value.data.message;
                    } else {
                        this.failureMessage = value.data.message;
                    }
                } else {
                    this.failureMessage = "Server Interruption"
                }

            }
        },
        watch: {
            'initialPrivacySelections': {
                handler: function (val) {
                    for (var i = 0; i < this.privacySettings.length; i++) {
                        this.privacySelections[i] = val.includes(this.privacySettings[i].id);
                    }
                },
                deep: true
            },
            'privacySettings': {
                handler: function () {
                    for (var i = 0; i < this.privacySettings.length; i++) {
                        this.privacySelections[i] = this.initialPrivacySelections.includes(this.privacySettings[i].id);
                    }
                    this.successMessage = '';
                    this.failureMessage = '';
                },
                deep: true
            },
            'successMessage': {
                handler: function () {
                    this.failureMessage = '';
                }
            },
            'failureMessage': {
                handler: function () {
                    this.successMessage = '';
                }
            }
        }
    }
</script>

<style scoped>
</style>